import { getRandomArrayElement } from '@root/src/utils/global';
import { PlayResponse } from '../../types';
import { getBalance, getRandomNonBonusBallColor } from './helper';

export function getLocalNoBonusPlayData(): PlayResponse {
    return {
        round: 'uid',
        step: 'uid',
        balance: getBalance() - 10,
        resp: {
            game_type: 'CRAZY_CRAZY_CLAW',
            win: true,
            color: getRandomNonBonusBallColor(),
            ball_type: 'CASH_REELS',
            top_slot: {
                type: getRandomArrayElement(['MULT_1', 'MULT_2', 'MULT_5', 'MULT_10']),
                types: ['MULT_1', 'MULT_2', 'MULT_5', 'MULT_10', 'BALL_SPIN', 'PLINKO', 'CASH_REELS', 'FORTUNE_WHEEL'],
                multiplier: '1',
                multipliers: ['1', '2', '3', '5', '10']
            },
            win_amount: 10000000 * 70,
            win_type: getRandomArrayElement(['BIG', 'SUPER', 'EPIC', 'MEGA'])
        },
        final: true
    };
}
